module.exports = __webpack_public_path__ + "static/media/XBOX6.ef1fdfcd.png";